import React, { useEffect, useRef } from 'react';
import { SearchIcon, X } from 'lucide-react';
interface HeaderProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}
export function Header({
  searchQuery,
  onSearchChange
}: HeaderProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  // Handle keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Cmd/Ctrl + K to focus search
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        inputRef.current?.focus();
      }
      // Escape to clear and blur
      if (e.key === 'Escape' && document.activeElement === inputRef.current) {
        onSearchChange('');
        inputRef.current?.blur();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onSearchChange]);
  const handleClear = () => {
    onSearchChange('');
    inputRef.current?.focus();
  };
  return <header className="bg-gradient-to-br from-[#8B1538] via-[#7A1230] to-[#5C0E24] text-white px-6 py-8 md:py-12" data-id="element-31">
      <div className="max-w-6xl mx-auto" data-id="element-32">
        <h1 className="text-2xl md:text-3xl font-bold mb-2 tracking-tight" data-id="element-33">
          Jin's Three Needles
        </h1>
        <p className="text-[#FECACA] text-sm md:text-base mb-8" data-id="element-34">
          Complete Clinical Reference & Treatment Guide
        </p>

        {/* Centered Search Bar */}
        <div className="max-w-2xl mx-auto" data-id="element-35">
          <div className="relative" data-id="element-36">
            <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-37" />
            <input ref={inputRef} type="text" placeholder="Search protocols, conditions, points, patterns, or any keyword..." value={searchQuery} onChange={e => onSearchChange(e.target.value)} className="w-full pl-12 pr-20 py-3.5 rounded-lg bg-white text-gray-800 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FECACA] shadow-lg" data-id="element-38" />
            <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-2" data-id="element-39">
              {searchQuery ? <button onClick={handleClear} className="p-1 text-gray-400 hover:text-gray-600 transition-colors rounded-full hover:bg-gray-100" title="Clear search" data-id="element-40">
                  <X className="h-4 w-4" data-id="element-41" />
                </button> : <span className="hidden sm:flex items-center gap-1 text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded" data-id="element-42">
                  <kbd className="font-sans" data-id="element-43">⌘</kbd>
                  <kbd className="font-sans" data-id="element-44">K</kbd>
                </span>}
            </div>
          </div>
          {searchQuery && <p className="text-center text-[#FECACA] text-xs mt-2" data-id="element-45">
              Press{' '}
              <kbd className="bg-white/20 px-1.5 py-0.5 rounded text-white" data-id="element-46">
                Esc
              </kbd>{' '}
              to clear
            </p>}
        </div>
      </div>
    </header>;
}